import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";
import ABCyaLib from '@abcya/abcya_lib';

export default class TrayBaseDraggers extends AContainer
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.adjX = 0;
        this.adjY = 0;

        this.tabs = [
          gameData.maskLocalization.getLocalizedString("tabNames.trim", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.color", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.patterns", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.faces", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.patches", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.letters", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.paint", gameData.maskLocalization.isDefault)
        ];

        this.accessories = [];
        this.isActive = false;

        this.createTray();
    }

    createTray()
    {
        this.nameplate = this.scene.addImage(55, -this.scene.maskAdj.y, "Tab", this);
        this.nameplateText = this.scene.addText(55, -this.scene.maskAdj.y + this.nameplate.height/2, 22, "0xFFFFFF", gameData.fonts.din_alternatebold, this.tabs[this.ind], this, true);

        this.type === "patch" ? this.nameplate.tint = "0xf98f10" : this.nameplate.tint = "0xef608c";
    }

    addDragFunctions(accessory)    
    {
        accessory.on('dragstart', (pointer)=>{
            this.scene.killTween(accessory);
            accessory.clearMask();

            gameData.isDragging = true;
            this.scene.playSound("pick_up_patch_letter");

            if(accessory.parentContainer === this) {
                this.adjX = this.scene.maskAdj.x + 13;
                this.adjY = this.scene.maskAdj.y;
                accessory.x += 13;
            } else {
                this.adjX = this.scene.maskAdj.x + this.scene.mid.x + 13;
                this.adjY = 385 + 25;
                accessory.x += this.scene.maskAdj.x + 395;
                accessory.y += 25;
            }

            this.scene.addAccessory(accessory, false, false, true);

            this.scene.addTween(accessory, 200, {scaleX:accessory.baseScale, scaleY:accessory.baseScale}, Phaser.Math.Easing.Quadratic.Out);
        });

        accessory.on('drag', (pointer, dragX, dragY)=>{
            accessory.x = dragX + this.adjX;
            accessory.y = dragY + this.adjY;
            if(this.scene.dragTools){
                this.scene.dragTools.x = accessory.x;
                this.scene.dragTools.y = accessory.y;
            };
        });
        
        accessory.on('dragend', (pointer)=>{
            this.scene.killTween(accessory);
            this.setDepth(8);
            gameData.isDragging = false;

            if(this.checkOverlap(accessory)){
                if(!accessory.isClone){
                    this.scene.playSound("patch_letters");

                    this.createNewAccessory(accessory);
                    this.scene.addAccessory(accessory, false, true);
                    accessory.x = accessory.startX;
                    accessory.y = accessory.startY;
                    accessory.setScale(gameData.defaultSpanish ? ABCyaLib.Environment.instance.gameConfig.spanishDefaults.letterScale : ABCyaLib.Environment.instance.gameConfig.letterTray.letterScale);

                    const localeCheck = ["á", "é", "í", "ñ", "ó", "ú", "ü"];
                    if(localeCheck.indexOf(accessory.frame.name) != -1) accessory.setScale(.15);
                } else {
                    this.scene.playSound("patch_letters");
                    this.scene.addAccessory(accessory, true, false);
                }
            } else {
                this.scene.removeTools();

                if(!accessory.isClone){
                    this.scene.addAccessory(accessory, false, true);
                    accessory.x -= this.scene.maskAdj.x + 13;
                    accessory.y -= this.scene.maskAdj.y;

                    const scale = gameData.defaultSpanish ? ABCyaLib.Environment.instance.gameConfig.spanishDefaults.letterScale : ABCyaLib.Environment.instance.gameConfig.letterTray.letterScale;
                    this.scene.addTween(accessory, 200, {x:accessory.startX, y:accessory.startY, scaleX:scale, scaleY:scale}, Phaser.Math.Easing.Quadratic.Out);
                } else {
                    accessory.disableInteractive();
                    if(this.scene.input._draggable.includes(accessory)) this.scene.input.setDraggable(accessory, false);

                    let accessoryID = gameData.accessories.indexOf(accessory);
                    gameData.accessories[accessoryID].destroy();
                    gameData.accessories.splice(accessoryID, 1);
                }
            }
        });
    }

    toggleBtns(unHidden)
    {
        if(unHidden){
            for(let i=0;i<this.list.length;i++){
                this.list[i].setInteractive();
                this.scene.input.setDraggable(this.list[i]);
            }
        } else {
            for(let i=0;i<this.list.length;i++){
                this.list[i].disableInteractive();
                if(this.scene.input._draggable.includes(this.list[i])) this.scene.input.setDraggable(this.list[i], false);
            }

            if(this.colors){
                for(let i=1;i<this.colors.length;i++){
                    this.colors[i].setEnabled(false);
                }
            }
        }

        if(this.colors){
            if(gameData.gameMode == 5) this.colors.forEach(color => {
                if(color.input) color.setEnabled(unHidden);
            });
        }
    }

    createNewAccessory(acc)
    {
      const localeRef = ["ñ", "á", "é", "í", "ó", "ú", "ü"];
      // const atlas = localeRef.indexOf(acc.frame.name) != -1 ? ABCyaPhaser.Images.LOCALIZATION_ATLAS : ABCyaPhaser.Images.DEFAULT_ATLAS;

      const newL = this.scene.addImage(acc.x - this.scene.faceMask.x, acc.y - this.scene.faceMask.y, acc.frame.name, this.scene.faceMask);
      newL.isClone = true;
      gameData.accessories.push(newL);
      newL.type = acc.type;
      newL.tint = acc.tint;
      newL.baseScale = .5;
      newL.setDepth(7);
      newL.setScale(newL.baseScale, newL.baseScale);
      newL.setInteractive();
      this.scene.input.setDraggable(newL);
      this.addDragFunctions(newL);
    }

    checkOverlap(obj)
    {
        let points = [obj.getTopLeft(), obj.getTopRight(), obj.getBottomRight(), obj.getBottomLeft()];
        let intersects = false;

        for(let i=0;i<points.length;i++){
            if(this.scene.faceMask.maskRef.contains(points[i].x, points[i].y)) intersects = true;
        }

        return intersects;
    }
}